const PartnerPromoCodes = () =>
  import(/* webpackChunkName 'PartnerPromoCodes' */ "@/components/PartnerPromoCodes/PartnerPromoCodes.vue");

export default {
  path: "partner_promo_codes",
  name: "partner_promo_codes",
  meta: {
    label: "Partner Promo Codes",
  },
  component: PartnerPromoCodes,
};
